import React, { useEffect, useState } from "react";
import { Download, X } from "lucide-react";

// Floating "Install app" prompt. Shows only when the browser fires
// beforeinstallprompt (Android/desktop Chrome). Dismissal is remembered.
export default function InstallPrompt() {
  const [deferred, setDeferred] = useState(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (localStorage.getItem("st_install_dismissed") === "1") return;
    const onPrompt = (e) => {
      e.preventDefault();
      setDeferred(e);
      setVisible(true);
    };
    const onInstalled = () => { setVisible(false); localStorage.setItem("st_install_dismissed", "1"); };
    window.addEventListener("beforeinstallprompt", onPrompt);
    window.addEventListener("appinstalled", onInstalled);
    return () => {
      window.removeEventListener("beforeinstallprompt", onPrompt);
      window.removeEventListener("appinstalled", onInstalled);
    };
  }, []);

  const install = async () => {
    if (!deferred) return;
    deferred.prompt();
    try { await deferred.userChoice; } catch { /* noop */ }
    setVisible(false);
    setDeferred(null);
  };

  const dismiss = () => { setVisible(false); localStorage.setItem("st_install_dismissed", "1"); };

  if (!visible) return null;

  return (
    <div
      className="fixed bottom-4 right-4 z-50 max-w-xs bg-[#111] border border-[#2a2a2a] rounded-xl p-4 shadow-2xl flex items-start gap-3"
      data-testid="install-prompt"
    >
      <div className="w-10 h-10 rounded-lg bg-[#dc2626]/15 flex items-center justify-center shrink-0">
        <Download size={18} className="text-[#dc2626]" />
      </div>
      <div className="min-w-0">
        <div className="text-sm font-semibold">Install ScareTickets</div>
        <div className="text-xs text-[#8a8a8a] mt-0.5">Add to your home screen for fast gate check-in.</div>
        <button onClick={install} className="st-btn mt-2 text-xs" data-testid="install-accept">Install app</button>
      </div>
      <button onClick={dismiss} className="text-[#8a8a8a] hover:text-white shrink-0" data-testid="install-dismiss" aria-label="Dismiss">
        <X size={16} />
      </button>
    </div>
  );
}
